module.exports = __webpack_public_path__ + "static/media/card-swipe-safes.dda8aa4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/card-swipe-safes.png
// module id = 1278
// module chunks = 0